import template from './loansCatalogCard.html';
import controller from './loansCatalogCard.controller';
import './loansCatalogCard.scss';

let loansCatalogCardComponent = {
  restrict: 'E',
  bindings: {
    loan: '<',
    creditworthiness: '<',
    isMobileApp: '<',
    serviceClosed: '<',
    userId: '<',
  },
  template,
  controller,
};

export default loansCatalogCardComponent;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/loansCatalog/loansCatalogCard/loansCatalogCard.component.js